import Session from '@polleverywhere/core/lib/models/session'
import store from '@polleverywhere/redux'
import { slice as profileSlice } from '@polleverywhere/redux/slices/profile'
import { updateSessionModelFromProfile } from './redux'
import { slice as appSlice } from '../slices/app'
import listenToSelector from '../util/listen_to_selector'

export default class BackboneSessionHelper {
  constructor (state) {
    this.state = state
    this.upgradePresenter = appSlice.selectAutomaticPresenterUpgrade(store.getState())
    this.session = new Session(state.get('user'), state.get('participant'), { upgradePresenter: this.upgradePresenter })
  }

  startSyncing () {
    // Only need to track session start from login component. Logging out is directly handled
    // in redux
    this.session.on('session:started', () => {
      const isLoggedIn = appSlice.selectIsFullyLoggedIn(store.getState())

      if (isLoggedIn) {
        const { user } = store.getState()[profileSlice.name]
        // if the user is a participant, convert them to presenter
        if (this.upgradePresenter && !user.account_id) {
          Backbone.ajax({
            method: 'POST',
            url: '/api/account'
          }).done((json) => {
            if (json) {
              store.dispatch(profileSlice.fetch({ updateCurrent: true, includeAccount: true }))
              this.state.get('user').set({ account: json })
              // must fetch the groups here since fetching them as a participant fails
              this.state.get('user').groups.fetch()
            }
          })
        }
      }

      // Session start could have an anonymous user
      if (this.state.get('user').id) {
        this.state.trigger('session:start', this.state.get('user'))
      } else {
        this.state.trigger('session:anonymous')
      }
    }, this)

    this.removeLoggedInSubscription = listenToSelector((state) => appSlice.selectIsFullyLoggedIn(state), (loggedIn) => {
      updateSessionModelFromProfile(this.session)

      if (!loggedIn) {
        this.state.trigger('session:logout')
      }
    })

    this.removeSessionStartSubscription = listenToSelector((state) => appSlice.selectIsSessionStarted(state), (started) => {
      // session (anonymous or authenticated) started
      if (started) {
        updateSessionModelFromProfile(this.session)
        this.session.trigger('session:started')
      }
    })

    return this
  }

  stopSyncing () {
    this.session?.off?.()
    this.removeLoggedInSubscription?.()
    this.removeSessionStartSubscription?.()
    return this
  }
}
